import script from "./DeleteAccountSuccess.vue?vue&type=script&setup=true&lang=js"
export * from "./DeleteAccountSuccess.vue?vue&type=script&setup=true&lang=js"

import "./DeleteAccountSuccess.vue?vue&type=style&index=0&id=c125db0a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c125db0a"]])

export default __exports__